<template>
  <v-app id="inspire">
    <v-card-title>
      Upgrade Package Template Data
      <v-dialog width="unset" height="unset" v-model="dialogs.addNewTemplate">
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="ml-5" color="secondary" v-bind="attrs" v-on="on"
            >Add new</v-btn
          >
        </template>
        <v-card class="pa-2" background="white" height="600" width="600">
          <v-textarea
            v-model="newTemplate"
            label="New package template"
            clearable
            no-resize
            rows="17"
          >
          </v-textarea>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" @click="dialogs.addNewTemplate = false"
              >close</v-btn
            >
            <v-btn
              color="primary"
              @click="
                addNewPackageTemplate(newTemplate);
                dialogs.addNewTemplate = false;
              "
              >Add template</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :search="search"
      :items="getUpgradePackageTemplate"
      :expanded.sync="expanded"
      :hide-default-footer="true"
      disable-pagination
      show-expand
      single-expand
      item-key="id"
    >
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-card-actions>
            <v-combobox
              :items="versionItems"
              v-model="versionFilter"
              dense
              filled
              chips
              label="Generate type"
              style="max-width: 220px; margin-right: 20px"
            ></v-combobox>
            <v-btn @click="generateUpgradePackage()" color="secondary"
              >Generate Package</v-btn
            >
          </v-card-actions>
          <!-- <v-text-field v-model="versionFilter" label="Version Filter" name="versionFilter" type="text"></v-text-field> -->
          <v-data-table
            :headers="subHeaders"
            :items="item.upgradePackages"
            :custom-sort="costumSort"
            item-key="id"
          >
            <!-- ACTIONS -->
            <template v-slot:item.actions="{ item }">
              <!-- SET STABLE TAG BUTTON -->
              <v-tooltip left v-if="!isStable(item)">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="setTag(item.id, 'STABLE')"
                  >
                    <v-icon>mdi-thumb-up-outline</v-icon>
                  </v-btn>
                </template>
                <span>Set stable</span>
              </v-tooltip>
              <!-- SET UNSTABLE TAG BUTTON -->
              <v-tooltip left v-if="isStable(item)">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="clearTag(item.id, 'STABLE')"
                  >
                    <v-icon>mdi-thumb-down-outline</v-icon>
                  </v-btn>
                </template>
                <span>Set unstable</span>
              </v-tooltip>
              <!-- DOWNLOAD BUTTON -->
              <v-btn
                icon
                @click="downloadUpgradePackageRelease(item.binaryFileId)"
              >
                <v-icon>mdi-download</v-icon>
              </v-btn>
              <v-btn icon @click="deleteUpgradePackageRelease(item.id)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </td>
      </template>
      <!-- ACTIONS -->
      <template v-slot:item.actions="{ item }">
        <v-btn icon @click="deleteUpgradePackageTemplate(item.id)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <c-confirmation-dialog ref="confirmationDialog"></c-confirmation-dialog>
  </v-app>
</template>

<script>
import {
  GET_UPGRADE_PACKAGE_TEMPLATE_QUERY,
  GENERATE_UPGRADE_PACKAGE,
  ADD_UPGRADE_PACKAGE_TEMPLATE,
  DELETE_UPGRADE_PACKAGE_TEMPLATE,
  GET_UPGRADE_PACKAGE_QUERY,
  SET_UPGRADE_PACKAGE_TAG,
  CLEAR_UPGRADE_PACKAGE_TAG,
  DELETE_UPGRADE_PACKAGE,
} from '../../graphql/upgradePackageQueries.js';
import { DownloadFileFromBinaryStorage } from '../../utils/UBinaryStorage';
export default {
  created() {
    this.refetchPackageTemplates();
  },
  components: {
    CConfirmationDialog: () => import('../common/CConfirmationDialog'),
  },
  data() {
    return {
      id: '',
      search: '',
      versionFilter: 'alpha',
      expanded: [],
      headers: [
        { text: 'Name', value: 'name', sortable: true },
        { text: 'Unit Type ID', value: 'unitTypeId', sortable: true },
        { text: 'Product ID', value: 'productId', sortable: true },
        { text: 'Application ID', value: 'applicationId', sortable: true },
        {
          text: '',
          value: 'actions',
          sortable: false,
          align: 'right',
          width: '10%',
        },
      ],
      getUpgradePackageTemplate: [],
      newTemplate: '',
      dialogs: {
        addNewTemplate: false,
      },
      subHeaders: [
        { text: 'Unit Type', value: 'unitTypeId', sortable: true },
        { text: 'Product', value: 'productId', sortable: true },
        { text: 'Application', value: 'applicationId', sortable: true },
        { text: 'Version', value: 'version', sortable: true },
        { text: 'Tags', value: 'tags', sortable: false },
        {
          text: '',
          value: 'actions',
          sortable: false,
          align: 'right',
          width: '15%',
        },
      ],
      versionItems: ['alpha', 'beta', 'release'],
    };
  },
  apollo: {
    $client: 'upgradePackageClient',
    getUpgradePackageTemplate: {
      query: GET_UPGRADE_PACKAGE_TEMPLATE_QUERY,
      loadingKey: 'loading',
    },
  },
  methods: {
    costumSort(items, index, isDesc) {
      let versionSortArray = [];
      items.sort((a, b) => {
        if (index[0] === 'version' || index[0] == undefined) {
          let j = 0;
          for (let i = items.length - 1; i >= 0; i--) {
            versionSortArray[j] = items[i];
            j++;
          }
          return versionSortArray;
        } else {
          if (!isDesc) {
            return a[index] < b[index] ? -1 : 1;
          } else {
            return b[index] < a[index] ? -1 : 1;
          }
        }
      });
      if (index == 'version') return versionSortArray;
      else return items;
    },
    refetchPackageTemplates() {
      this.$apollo.queries.getUpgradePackageTemplate.refetch();
    },
    async generateUpgradePackage() {
      try {
        const templateId = this.expanded[0].id;
        const versionOverride = '';
        let finalVersion = this.versionFilter;
        if (this.versionFilter == 'release') finalVersion = '';
        await this.$apollo.mutate({
          mutation: GENERATE_UPGRADE_PACKAGE,
          variables: {
            upgradePackageTemplateId: templateId,
            versionFilter: finalVersion,
            versionOverride: versionOverride,
          },
        });
        this.refetchPackageTemplates();
        alert('Successfully generated upgrade package!');
      } catch (error) {
        alert('The service was not able to generate upgrade package.');
      }
    },

    async addNewPackageTemplate(template) {
      console.log('Adding new template: ' + template);

      try {
        const response = await this.$apollo.mutate({
          mutation: ADD_UPGRADE_PACKAGE_TEMPLATE,
          variables: {
            upgradePackageTemplate: JSON.parse(this.newTemplate),
          },
        });
        const responseData = response.data.addOrUpdateUpgradePackageTemplate[0];
        alert(
          'Successfully create new template: ' +
            responseData.name +
            ' - ' +
            responseData.id
        );
      } catch (error) {
        alert('Error creating new template! ' + error.message);
      }
    },
    async deleteUpgradePackageTemplate(id) {
      console.log(this.$refs.confirmationDialog);
      if (
        await this.$refs.confirmationDialog.open(
          'Are you sure you want to delete this template?'
        )
      ) {
        try {
          const response = await this.$apollo.mutate({
            mutation: DELETE_UPGRADE_PACKAGE_TEMPLATE,
            variables: {
              id: id,
            },
          });
          console.log(response);
          this.refetchPackageTemplates();
        } catch (error) {
          alert('Error deleting template! ' + error.message);
        }
      }
    },

    async deleteUpgradePackageRelease(id) {
      if (
        await this.$refs.confirmationDialog.open(
          'Are you sure you want to delete this package?'
        )
      ) {
        try {
          const response = await this.$apollo.mutate({
            mutation: DELETE_UPGRADE_PACKAGE,
            variables: {
              id: id,
            },
          });
          console.log(response);
          this.refetchPackageTemplates();
        } catch (error) {
          alert('Error deleting package! ' + error.message);
        }
      }
    },

    async downloadUpgradePackageRelease(binaryFileId) {
      DownloadFileFromBinaryStorage(binaryFileId);
    },

    async setTag(packageId, tag) {
      try {
        //const packageId = this.expanded[0].id;
        await this.$apollo.mutate({
          mutation: SET_UPGRADE_PACKAGE_TAG,
          variables: {
            upgradePackageId: packageId,
            tag: tag,
          },
          refetchQueries: [{ query: GET_UPGRADE_PACKAGE_QUERY }],
        });
      } catch (error) {
        alert('Service failed setting tag.');
      }
    },

    async clearTag(packageId, tag) {
      try {
        //const packageId = this.expanded[0].id;
        await this.$apollo.mutate({
          mutation: CLEAR_UPGRADE_PACKAGE_TAG,
          variables: {
            upgradePackageId: packageId,
            tag: tag,
          },
          refetchQueries: [{ query: GET_UPGRADE_PACKAGE_QUERY }],
        });
      } catch (error) {
        alert('Service failed clearing tag.');
      }
    },

    isStable(item) {
      return item.tags.some((tag) => tag === 'STABLE');
    },
  },
};
</script>
